import React from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import Header from "../components/header";
import Footer from "../components/footer";

const plans = [
  {
    feature: "Place Bids per Day",
    free: "3/day",
    pro: "15/day",
    elite: "Unlimited",
  },
  {
    feature: "Bid Frequency",
    free: "Every 30 mins",
    pro: "Every 15 mins",
    elite: "Every 10 mins",
  },
  {
    feature: "Visibility in Search",
    free: "Normal",
    pro: "Higher",
    elite: "Top",
  },
  {
    feature: "Bid Notifications",
    free: "No",
    pro: "Yes",
    elite: "Yes (Priority)",
  },
  {
    feature: "Access to “First Dibs” Services",
    free: "No",
    pro: "No",
    elite: "✅",
  },
  {
    feature: "Custom Shop Page Branding",
    free: "No",
    pro: "✅",
    elite: "✅",
  },
  {
    feature: "Analytics Dashboard",
    free: "No",
    pro: "Basic",
    elite: "Advanced",
  },
  {
    feature: "Price (Monthly)",
    free: "Free",
    pro: "$29",
    elite: "$99",
  },
];

const TermsOfService = () => {
  return (
    <>
      {/* Shared Header */}
      <Header />

      <Box
        sx={{
          p: 4,
          backgroundColor: "#f5f7fa",
          minHeight: "80vh",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: "20px",
            maxWidth: "1000px",
            mx: "auto",
            backgroundColor: "#ffffff",
          }}
        >
          {/* Title */}
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#4285f4" }}
          >
            SAAS Pricing Plans
          </Typography>

          <Typography
            variant="subtitle1"
            align="center"
            sx={{ mb: 3, color: "#555" }}
          >
            Choose the plan that fits your business needs
          </Typography>

          {/* Pricing Table */}
          <TableContainer component={Paper} elevation={1}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#4285f4" }}>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Features
                  </TableCell>
                  <TableCell align="center" sx={{ color: "#fff" }}>
                    Free
                  </TableCell>
                  <TableCell align="center" sx={{ color: "#fff" }}>
                    Pro
                  </TableCell>
                  <TableCell align="center" sx={{ color: "#fff" }}>
                    Elite
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {plans.map((row, idx) => (
                  <TableRow
                    key={idx}
                    sx={{
                      "&:nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
                    }}
                  >
                    <TableCell sx={{ fontWeight: 500 }}>
                      {row.feature}
                    </TableCell>
                    <TableCell align="center">{row.free}</TableCell>
                    <TableCell align="center">{row.pro}</TableCell>
                    <TableCell align="center">{row.elite}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>

      {/* Shared Footer */}
      <Footer />
    </>
  );
};

export default TermsOfService;
